import { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { createPortal } from 'react-dom';

// Founders : vidéos notées « déjà posté / déjà fait » mais pas finies dans ASA → validation groupée.
export const AlreadyPostedButton = ({ onDone }) => {
  const [videos, setVideos] = useState([]);
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState(new Set());
  const [busy, setBusy] = useState(false);
  const load = () => api.get('/admin/already-posted').then((r) => {
    setVideos(r.data.videos || []);
    setSel(new Set((r.data.videos || []).map((v) => v.id)));
  }).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!videos.length) return null;
  const toggle = (id) => setSel((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const apply = async () => {
    setBusy(true);
    try {
      const r = await api.post('/admin/already-posted/apply', { ids: [...sel] });
      toast.success(`${r.data.marked} vidéo(s) passée(s) en « Postée » ✓`);
      setOpen(false);
      await load();
      onDone?.();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Erreur'); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid="already-posted-btn" onClick={() => setOpen(true)} className="asa-btn"
        style={{ background: 'rgba(52,211,153,0.14)', border: '1.5px solid rgba(52,211,153,0.4)', color: '#34D399' }}>
        <CheckCircle2 size={14} /> « Déjà posté »
        <span style={{ background: '#34D399', color: '#06281C', padding: '1px 7px', borderRadius: 999, fontFamily: 'Sora', fontWeight: 800, fontSize: '0.62rem', marginLeft: 4 }}>{videos.length}</span>
      </button>
      {open && createPortal(
      <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(3,6,18,0.72)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div data-testid="already-posted-dialog" onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 560, background: 'linear-gradient(180deg, #1a2242 0%, #101632 100%)', border: '1px solid rgba(52,211,153,0.3)', borderRadius: 18, padding: 22, color: '#EDF1FB', boxShadow: '0 24px 60px rgba(0,0,0,0.55)' }}>
          <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 17, marginBottom: 6 }}>Vidéos notées « déjà posté / déjà fait »</div>
          <div style={{ fontSize: 13, color: 'var(--text-dim)', marginBottom: 8 }}>Elles sont encore « à poster » dans ASA. Coche celles à passer en « Postée ».</div>
          <div style={{ maxHeight: '55vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
            {videos.map((v) => (
              <label key={v.id} data-testid={`already-posted-row-${v.id}`} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '8px 10px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.08)', cursor: 'pointer' }}>
                <input type="checkbox" checked={sel.has(v.id)} onChange={() => toggle(v.id)} data-testid={`already-posted-check-${v.id}`} style={{ marginTop: 3, accentColor: '#34D399' }} />
                <div>
                  <div style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 13 }}>{v.publication_title || v.title}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--text-dim)' }}>{v.project_name}{v.scheduled_post_date ? ` · prévu le ${new Date(v.scheduled_post_date.slice(0, 10) + 'T12:00:00').toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })}` : ''} · {({ todo: 'À faire', in_progress: 'En cours', review: 'À valider', to_post: 'À poster', redo: 'En correction' })[v.stage] || v.stage}</div>
                </div>
              </label>
            ))}
          </div>
          <button data-testid="already-posted-apply" disabled={busy || !sel.size} onClick={apply} className="asa-btn asa-btn-primary" style={{ marginTop: 12, width: '100%', justifyContent: 'center' }}>
            {busy ? 'En cours…' : `Passer ${sel.size} vidéo(s) en « Postée »`}
          </button>
          <button data-testid="already-posted-close" onClick={() => setOpen(false)} style={{ marginTop: 8, width: '100%', padding: '10px 0', borderRadius: 10, background: 'transparent', border: '1px solid rgba(255,255,255,0.14)', color: '#A5AFC7', fontFamily: 'Sora', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>Fermer</button>
        </div>
      </div>, document.body)}
    </>
  );
};
